import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import styles from './Spinner.module.scss';

interface SpinnerProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  style?: CSSProperties;
  [key: string]: any;
}

const Spinner: React.FC<SpinnerProps> = ({ className = '', width, height, style = {}, ...props }) => (
  <div
    className={classnames(styles.Spinner, className)}
    style={{ height, width, ...style }}
    {...props}
  >
    <i style={{ fontSize: height }} className="fas fa-spinner" />
  </div>
);

export default Spinner;
